import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RiderAuthenticationState } from './rider-authentication.state';

export const AuthenticationState = createFeatureSelector<RiderAuthenticationState>('riderAuthentication');

export const getAuthenticationStatus = createSelector(AuthenticationState, (state: RiderAuthenticationState) => state.authenticationStatus);

export const getAuthenticatedRider = createSelector(AuthenticationState, (state: RiderAuthenticationState) => state.authenticatedRider);

export const getIsPerformingAuthenticationAction = createSelector(
  AuthenticationState,
  (state: RiderAuthenticationState) => state.isPerformingAuthenticationAction
);

export const getEmailVerificationCredentials = createSelector(
  AuthenticationState,
  (state: RiderAuthenticationState) => state.emailVerificationCredentials
);

export const getIsRehydrated = createSelector(AuthenticationState, (state: RiderAuthenticationState) => state.isRehydrated);

export const getRiderAddress = createSelector(AuthenticationState, (state: RiderAuthenticationState) => state.riderAddress);

export const getIsSavingRiderData = createSelector(AuthenticationState, (state: RiderAuthenticationState) => state.isSavingRiderData);

export const getIsRefreshingAuthenticatedRider = createSelector(
  AuthenticationState,
  (state: RiderAuthenticationState) => state.isRefreshingAuthenticatedRider
);

export const getCurrentDeviceInstallation = createSelector(
  AuthenticationState,
  (state: RiderAuthenticationState) => state.currentDeviceInstallation
);

export const getMobilityProfileDetail = createSelector(
  AuthenticationState,
  (state: RiderAuthenticationState) => state.mobilityProfile.mobilityProfileDetail
);

export const getModifiedMobilityProfileDetail = createSelector(
  AuthenticationState,
  (state: RiderAuthenticationState) => state.mobilityProfile.modifiedMobilityProfileDetail
);

export const getIsMobilityProfileUpdating = createSelector(
  AuthenticationState,
  (state: RiderAuthenticationState) => state.mobilityProfile.isUpdating
);

export const getIsRiderSuspended = createSelector(
  AuthenticationState,
  (state: RiderAuthenticationState) => state.authenticatedRider?.suspended
);
